import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Unit} from '../dashboard/monitoring/unit';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnitCardDataService {

  constructor(
    private http: HttpClient
  ) { }

  public getUnitData(unitId: number): Observable<Unit> {
    const httpParams = (new HttpParams()).append(
      'expand',
      [
        'unitModel',
        'unitModel.chargingStationPort01ConnectorType',
        'unitModel.chargingStationPort02ConnectorType',
        'unitModel.chargingStationPort03ConnectorType',
        'unitModel.chargingStationPort04ConnectorType',
        'unitModel.project',
        'unitType',
        'lastMsgUnit' ,
        'activeOrder',
        'activePrepaidSharingOrder',
        'activeOrder.endUser',
        'activeOrder.endUserOrderIntervals',
        'activeOrder.how_order_was_paid',
        'lastFinishedOrCancelledOrder',
        'lastFinishedOrCancelledOrder.unitImagesShort.thumbnail',
        'lastFinishedOrCancelledOrder.end_user_full_name',
        'lastFinishedOrCancelledOrder.paymentMethods',
        'lastFinishedOrCancelledOrder.debt',
        'lastFinishedOrCancelledOrder.currency_code',
        'lastFinishedOrCancelledOrder.finish_by_user_name',
        'lastFinishedOrCancelledOrder.finish_by_source',
        'lastFinishedOrCancelledOrder.finish_by_end_user_notification_id',
        // 'endUserPricePlans',
        'address',
        'speed',
        'sats',
        'gsm',
        'unitIsInService',
        'activeOrder.currency_code',
        'height',
        'availabilityStatus',
        'lbsLac',
        'lbsCountryCode',
        'lbsOperatorId',
        'lbsCellId',
        'hwModel',
        // 'endUserPricePlans.translatedName',
        // 'endUserPricePlans.translatedDescriptionSpeedMode',
        // 'endUserPricePlans.translatedDescriptionPrice',
        // 'endUserPricePlans.translatedDescriptionTitle1',
        // 'endUserPricePlans.translatedDescriptionTitle2',
        // 'endUserPricePlans.translatedDescriptionTitle3',
        // 'endUserPricePlans.translatedDescriptionTitle4',
        // 'endUserPricePlans.translatedDescriptionValue1',
        // 'endUserPricePlans.translatedDescriptionValue2',
        // 'endUserPricePlans.translatedDescriptionValue3',
        // 'endUserPricePlans.translatedDescriptionValue4',
        'battery',
        'attachedUnit',
        'attachedToUnit',
        'attachedToBattery',
        'prepaidSharingWebAppUrl',
        'prepaidPricePlans',
        'prepaidPricePlans.currentTranslation',
        'unitDemands',
        'unitDemands.geofenceName',
        'unitDemands.regionName',
        'unitDemands.businessLogicCustomName',
        'unitDemands.businessLogicType',
        'businessLogics',
        'writtenOffByUser',
      ].join(',')
    );

    return this.http.get<Unit>(
      environment.apiBasepoint + 'unit/' + unitId.toString(),
      {
        params: httpParams,
        observe: 'body'
      }
    );
  }
}
